import React, { ReactElement } from 'react'

import { dynamicClassName } from 'styles/helper'

import styles from './Checkbox.module.less'

export type CheckboxProps = {
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  background?: boolean
  label: string
  isChecked?: boolean
  largeText?: boolean
}

export default function Checkbox({
  onClick,
  onChange,
  background,
  label,
  isChecked,
  largeText,
}: CheckboxProps): ReactElement {
  return (
    <div
      onClick={(ev) => {
        onClick && onClick(ev)
      }}
      className={dynamicClassName({
        [styles.Checkbox_Background]: true,
        [styles.Checkbox_Background__color]: !!background,
      })}
    >
      <input
        type="checkbox"
        id="checkbox"
        name={label}
        value={label}
        checked={isChecked}
        onChange={(ev) => {
          onChange && onChange(ev)
        }}
      />
      <label
        htmlFor={label}
        className={dynamicClassName({
          [styles.Checkbox_Label]: true,
          [styles.Checkbox_Label_largeText]: !!largeText,
        })}
      >
        {label}
      </label>
    </div>
  )
}
